import { useEffect, useState } from 'react';
import { UseFormGetValues } from 'react-hook-form';

import { UnitPosition } from '~/data/unitPositions';
import { getCustomDataUnitPosition } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/data';
import {
  IndexedUpCustomDataAttribute,
  UpCustomData,
  customDataAttributes,
} from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/data/customDataUnitPosition';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
export type UseUnitPositionPercentageOutput = {
  upCustomData: UpCustomData[];
  filteredUnitPositions: UnitPosition[] | undefined;
  countTotalPercent: (oldValue: number, newValue: number) => void;
  totalPercent: number;
  upCustomDataAttribute: IndexedUpCustomDataAttribute;
  loading: boolean;
};

export const useUnitPositionPercentage = (
  unitPositions: UnitPosition[],
  selectedUnitPositionIds: number[],
  getValues: UseFormGetValues<Form>,
  index: number,
): UseUnitPositionPercentageOutput => {
  const [filteredUnitPositions, setFilteredUnitPositions] =
    useState<UnitPosition[]>();
  const [upCustomData, setUpCustomData] = useState<UpCustomData[]>([]);
  const [upCustomDataAttribute, setUpCustomDataAttribute] =
    useState<IndexedUpCustomDataAttribute>({});
  const [totalPercent, setTotalPercent] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setFilteredUnitPositions(
      unitPositions.filter(
        (up) => selectedUnitPositionIds.indexOf(up.fUnitPositionId) !== -1,
      ),
    );
  }, [selectedUnitPositionIds, unitPositions]);

  useEffect(() => {
    const allFormValues = getValues();
    const addRegisteredPercent = selectedUnitPositionIds.reduce(
      (acc, upid) =>
        acc +
          (allFormValues.schedule?.[index]?.empPosition?.[
            `${upid}-percent`
          ] as number) || 0,
      0,
    );
    setTotalPercent(addRegisteredPercent);
  }, [getValues, index, selectedUnitPositionIds]);

  //TODO: FIX THE FETCHING, FLOW, LOADER
  useEffect(() => {
    setLoading(true);
    (async () => {
      setUpCustomData(await getCustomDataUnitPosition());
      setUpCustomDataAttribute(await customDataAttributes());
      setLoading(false);
    })();
  }, []);

  const countTotalPercent = (oldValue: number, newValue: number) => {
    setTotalPercent(totalPercent - (oldValue || 0) + (newValue || 0));
  };

  return {
    upCustomData,
    filteredUnitPositions,
    countTotalPercent,
    totalPercent: totalPercent || 0,
    upCustomDataAttribute,
    loading,
  };
};
